import PropTypes from 'prop-types';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';

import './PropertyTypeSectionCard.scss';

const PropertyTypeSectionCard = ({ type }) => {
  const PropertyTypeSectionCardName = trans(
    `property.type.section.card.${type}`
  );
  const PropertyTypeSectionCardDescription = trans(
    `property.type.section.card.description.${type}`
  );

  return (
    <div className="property-type-section-card">
      <LazyLoad
        height={200}
        offset={150}
        once
        as="figure"
        className="property-type-section-card__image"
      >
        <img
          src={getResourcePath(
            `/images/home/property-type-redesign/${type}.jpg`
          )}
          alt={PropertyTypeSectionCardName}
          loading="lazy"
        />
      </LazyLoad>

      <div className="property-type-section-card__info">
        <h3 className="property-type-section-card__info-title">
          <span className="property-type-section-card__info-title-label">
            {PropertyTypeSectionCardName}
          </span>
        </h3>
        <span className="property-type-section-card__info-description">
          {PropertyTypeSectionCardDescription}
        </span>
      </div>
    </div>
  );
};

PropertyTypeSectionCard.propTypes = {
  type: PropTypes.string.isRequired
};

export default PropertyTypeSectionCard;
